module.exports = __webpack_public_path__ + "static/media/MHSB999.fba4d349.png";